import { cn } from '@/lib/utils/cn.js';

const BANK_LOGO_FILES = new Set([
  'baac', 'bay', 'bbl', 'cimb', 'ghb', 'gsb', 'kbank', 'kkp', 'ktb', 'lhb', 'scb', 'tisco', 'tmb', 'ttb', 'uob',
]);

// code → filename when it isn't simply lowercase(code).
// LHBANK ships as lhb.svg; TMB is the legacy mark for the merged TTB.
const BANK_CODE_ALIAS: Record<string, string> = { LHBANK: 'lhb', TMB: 'tmb' };

export function bankLogoUrl(code: string | null | undefined): string | null {
  if (!code) return null;
  const up = code.toUpperCase();
  const file = (BANK_CODE_ALIAS[up] ?? up).toLowerCase();
  return BANK_LOGO_FILES.has(file) ? `/banks/${file}.svg` : null;
}

export function BankLogo({ code, size = 40, className }: { code: string; size?: number; className?: string }) {
  const url = bankLogoUrl(code);
  if (url) {
    return (
      <img
        src={url}
        alt={code}
        className={cn('shrink-0 rounded-lg border border-[var(--border)] object-contain', className)}
        style={{ width: size, height: size }}
        loading="lazy"
      />
    );
  }
  return (
    <span
      className={cn(
        'grid place-items-center shrink-0 rounded-lg bg-[var(--bg-elevated)] font-mono font-bold text-[var(--text-secondary)]',
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.26)) }}
    >
      {code}
    </span>
  );
}
